import request from '@/service/index'
import qs from 'qs'

// 获取数据云仓列表
export const getStoreList = (params: any) => {
  return request({
    url: '/userdb/GetList',
    method: 'GET',
    params
  })
}

// 编辑、创建数据云仓
export const submitStore = (data: any) => {
  return request({
    url: '/userdb/save',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 删除云仓
export const deleteStore = (params: any) => {
  return request({
    url: '/userdb/delete',
    method: 'GET',
    params
  })
}
